import WidgetBase from '../widget.base';
import ColorBars from '../../services/color-bars';

export default class SimpleGraphicalCalloutGrid extends WidgetBase {
    static selector = '[data-ww-simple-graphical-callout-grid]';

    constructor(el){
        super(el);

        this.$colorbars = el.querySelector('.ww-simple-graphical-callout-grid__color-bars');

        setTimeout(() => {
            this.colorBars = new ColorBars(this.$colorbars);
            this.loaded();
        },500)
    }
}